import { Registration } from "@p0security/shared/integrations/types";

import { SplunkComponents } from "./components.ts";
import { SplunkIconUrl } from "./icon.ts";

export { SplunkIconUrl };

export const SplunkRegistration = Registration({
  category: "other",
  components: SplunkComponents,
  docs: {},
  itemKind: "token",
  label: "Splunk",
  logoUrl: SplunkIconUrl,
  maturity: "ga",
});
